// extracted by mini-css-extract-plugin
module.exports = {"gradientBackground":"index-module_gradientBackground_3YhIF","safeArea":"index-module_safeArea_3aeyY","customeThemeBox":"index-module_customeThemeBox_1JN7j"};